module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic2.0bc3812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic2.png
// module id = 585
// module chunks = 1